import React from "react";
import { Link } from "react-router-dom";

export default function PremiumBackLink({ to, destination }) {
  const label = `Wstecz – ${destination}`;
  return (
    <Link to={to} className="btn btn-outline-primary premium-back-link">
      <i className="bi bi-arrow-left" aria-hidden="true" /> {label}
    </Link>
  );
}
